const roleOrder = {
  owner: 0,
  editor: 10,
  commenter: 20,
  viewer: 30
};
const sortPermissionsByRole = (order = "ASC") => (a, b) => {
  return (roleOrder[a.role] - roleOrder[b.role]) * (order === "ASC" ? 1 : -1);
};

export { roleOrder, sortPermissionsByRole };
//# sourceMappingURL=sortByPermissionRole.js.map
